import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Hero from '../../components/layouts/Hero';
import illustration from '../../images/undraw_visual_data_b1wx.svg';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Button = makeShortcode("Button");
const layoutProps = {
  _frontmatter
};
const MDXLayout = Hero;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <pre><code parentName="pre" {...{
        "className": "language-sequence",
        "metastring": "autoFocus",
        "autoFocus": true
      }}>{`Alice->Bob: Hello
Bob-->Alice: Hi!
`}</code></pre>
    <hr></hr>
    <h1>{`Hassle free diagrams.`}</h1>
    <p>{`Stop wasting time drag-n-dropping diagrams yourself...`}<br />{`
Turn code into beautiful diagrams and integrate it in one click.`}</p>
    <Button primary to="/sequence-diagram" mdxType="Button">Start creating</Button>


    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      